import userApi from '@/api/user';
import { authActions } from '@/stores/authStore';

document.addEventListener('visibilitychange', async () => {
  if (document.visibilityState === 'visible') {
    try {
      await userApi.getUserInfo();
    } catch (error) {
      if (error?.response?.status >= 400) {
        authActions.logout();
      }
    }
  }
});
